import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective, MDBDatePickerComponent } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { RecorridoService } from 'src/app/services/recorrido.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';

@Component({
  selector: 'app-modal-seleccionar-recorrido-liquidacion',
  templateUrl: './modal-seleccionar-recorrido-liquidacion.component.html',
  styleUrls: ['./modal-seleccionar-recorrido-liquidacion.component.scss'],
  providers: [SecurityService]
})
export class ModalSeleccionarRecorridoLiquidacionComponent implements OnInit {

  // Output
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onNotFound: EventEmitter<any> = new EventEmitter<any>();

  // Modales
  @ViewChild('seleccionarRecorrido', { static: true }) seleccionarRecorridoModal: ModalDirective;
  @ViewChild('dpFecha', { static: true }) dpFecha: MDBDatePickerComponent

  // Form
  formHeader: FormGroup

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  loading: boolean = false
  listaRecorridos: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()
  HighlightRow : Number;
  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private recorridoService: RecorridoService,
    private messageRendererService: MessageRendererService,
    private rutService: RutService
  ) {
    this.log = this.clog.log('SELECCIONAR RECORRIDO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10

    this.createForm()
  }

  private createForm() {
    this.formHeader = this.fb.group({
      chofer: [null, []],
      codigoRecorrido: [null, []],
      fecha: [null, []]
    });
  }

  ClickedRow(index, recorrido){
    this.HighlightRow = index;
    console.log("MUESTRAME EL RECORRIDO NO MODAL ", recorrido)
    this.seleccionar(recorrido);
  }

  show() {
    this.clearAllData()
    this.seleccionarRecorridoModal.show()
  }

  private clearAllData() {
    this.formValidatorsService.reset(this.formHeader)
    this.dpFecha.clearDate()
    this.listaRecorridos = null
  }

  buscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    this.paginationContext.CurrentPage = pageNumber

    this.listaRecorridos = []
    this.loading = true

    const { codigoRecorrido, chofer, fecha } = this.formHeader.value
    const inputParams = {
      codigo: codigoRecorrido ? codigoRecorrido : -1,
      chofer_rut: chofer ? this.rutService.QuitarDV(this.rutService.Limpiar(chofer)) : -1,
      fecha,
      camion_patente: '',
      sucursal_codigo: this.sucursalCodigo,
      rut_empresa: this.rutEmpresa,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.recorridoService.obtenerRecoridosALiquidar(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.listaRecorridos = registros
      this.listaRecorridos.map(recorrido => {
        recorrido.rutChoferFormato = this.rutService.AgregarDV(recorrido.chofer_rut)
      })
      this.loading = false
    })
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

  seleccionar(recorrido) {
    console.log("MUESTRAME EL RECORRIDO MODAL ", recorrido)

    this.lastCodigoRecorrido = recorrido.codigo

    delete recorrido.rutChoferFormato
    delete recorrido.__typename

    this.onSelect.emit(recorrido)
    this.seleccionarRecorridoModal.hide()
  }


  /********* OUTSIDE CALL *********/
  lastCodigoRecorrido: number = 0
  // Método para ser consumido desde fuera del componente
  public searchByCodigo(codigo: number) {
    // this.log(this.lastCodigoRecorrido, codigo)
    if (this.lastCodigoRecorrido !== codigo && codigo && codigo !== 0) {
      this.lastCodigoRecorrido = codigo

      const inputParams = {
        codigo,
        chofer_rut: -1,
        camion_patente: '',
        sucursal_codigo: this.sucursalCodigo,
        rut_empresa: this.rutEmpresa,
        fecha: null,
        paginaActual: 1,
        cantidadRegistrosPorPagina: 10
      }
      this.recorridoService.obtenerRecoridosALiquidar(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null
        if (!ok) {
          this.messageRendererService.showErrors(mensajes)
          return
        }

        const { registros } = respuesta
        if (registros && registros.length === 1) {
          // Si encuentra exactamente 1 resultado, seleccionarlo automáticamente
          this.seleccionar(registros[0])
          // this.clearLast()
        } else {
          // Si encuentra 0 o múltiples resultados, NO hacer nada
          // No llamar a notFound() para evitar borrar el campo que el usuario está escribiendo
          // El usuario puede continuar escribiendo sin interrupciones
        }
      })
    }
  }

  private notFound() {
    this.onNotFound.emit()
  }

  public clearLast() {
    this.lastCodigoRecorrido = 0
  }
  /********* OUTSIDE CALL *********/

}
